import { ChangeEvent, ReactNode } from 'react';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { RadioField } from '@/components/form/fields/RadioGroup/RadioField';
import { Wrapper } from '@/components/form/fields/PanelRadioGroup/styles';
import { InputError } from '@/components/form/fields/InputError/InputError';

export type PanelRadioGroupOptionType = {
  value: string;
  label: string;
  icon?: ReactNode;
  disabled?: boolean;
};

type PanelRadioGroupType = {
  label: ReactNode;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  options: PanelRadioGroupOptionType[];
  disabled?: boolean;
  apiError?: string;
};

export const PanelRadioGroup = ({ label, onChange, value, options, disabled, apiError }: PanelRadioGroupType) => {
  const labelColor = disabled ? COLORS.grey[650] : COLORS.grey[950];

  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      <Typography width='100%' variant='bodySmall' color={COLORS.grey[950]} textAlign='start' marginBottom='8px'>
        {label}
      </Typography>
      <Box width='100%' display='flex' alignItems='center' columnGap='12px'>
        {options.map((option, index) => {
          const key = `${index}_${option.label}`;
          const checked = value === option.value;

          return (
            <Wrapper key={key} isChecked={checked} disabled={disabled}>
              <Box display='flex' flexDirection='column' rowGap='8px'>
                {option.icon}
                <Typography color={labelColor} variant='bodySmall' fontWeight='medium'>
                  {option.label}
                </Typography>
              </Box>
              <Box>
                <RadioField
                  key={key}
                  onChange={onChange}
                  value={option.value}
                  checked={checked}
                  disabled={option.disabled || disabled}
                />
              </Box>
            </Wrapper>
          );
        })}
      </Box>
      <Box width='100%' display='flex' alignItems='center' justifyContent='start'>
        <InputError apiError={apiError} />
      </Box>
    </Box>
  );
};
